module.exports = __webpack_public_path__ + "img/maintenance.5e6fdb6f.svg";